import Dots from '@discover-ui/dots';

type AvailabilityStatusProps = {
  availableLabel?: string;
  status: 'available' | 'unavailable' | 'processing' | 'sold' | 'closed' | 'placeholder';
};

export default function AvailabilityStatus({ status, availableLabel }: AvailabilityStatusProps) {
  if (status === 'processing') {
    return <Dots />;
  }

  if (status === 'closed') {
    return <span>Closed</span>;
  }

  if (status === 'unavailable') {
    return <span>{availableLabel}</span>;
  }

  if (status === 'placeholder') {
    return <span />;
  }

  if (status === 'sold') {
    return <span>Sold</span>;
  }

  // available
  return <span>{availableLabel}</span>;
}
